import React, { useEffect, useState } from 'react';
import { Bet, TicketLineStatus } from '../types'
import { useBetContext } from '../context/BetContext';
import BetStatusLabel from './BetStatusLabel';
// import BetOddsDisplay from './BetOddsDisplay';
import BetRemoveButton from './BetRemoveButton';
import BetConnector from './BetConnector';
import { useI18n } from '../context/I18nContext';
import { getEnumKeyByValue } from '../utils/utils'

interface BetLineProps {
  bet: Bet;
  displayRemoveIcon: boolean;
  showLine: boolean;
  flashOddsInterval: number;
  closedOrSuspended:boolean;
}

const BetLine: React.FC<BetLineProps> = ({
  bet,
  displayRemoveIcon,
  showLine,
  flashOddsInterval,
  closedOrSuspended
}) => {
  const { removeBets, config } = useBetContext();
  const [flash, setFlash] = useState(false);
  const [showArrow, setShowArrow] = useState(false);
  const { t } = useI18n();
  const statusLabel = bet.closed ? t('betBuilder.closed') : bet.suspended ? t('betBuilder.suspend'):'';
  const oddsChangedFlag =
    bet.previouseOdds !== undefined && bet.previouseOdds !== bet.odds;

  useEffect(() => {
    if (bet.closed || bet.suspended) {
      setFlash(false);
      setShowArrow(false);
      return;
    }

    if (oddsChangedFlag) {
      setFlash(true);
      setShowArrow(true);

      const timer = setTimeout(() => {
        setFlash(false);
      }, flashOddsInterval);

      return () => clearTimeout(timer);
    }
  }, [bet.odds]);
  
  const lineStatusString = getEnumKeyByValue(TicketLineStatus, bet.lineStatus || -1)

  return (
    <div className="bet-info relative rounded-md p-[8px] flex min-h-[40px] items-center bg-background border border-border">
      {!closedOrSuspended && (
        <BetStatusLabel status={statusLabel} />
      )}
      <BetConnector showLine={showLine} lineStatusString={lineStatusString} />
      <div className="market-name bet flex-1 pl-[28px] pt-4">
        <div className="bet-name flex justify-between items-center">
          <span className="text-sm font-medium text-foreground mr-auto">
            {bet.marketName}
            {lineStatusString === 'Refund' && (
              <>
                <span> - </span>
                <span className="text-[var(--refund)]">{lineStatusString}</span>
              </>
            )}
          </span>
          {/* not in design */}
          {/*{!config.calculationResultBottom && (*/}
          {/*  <BetOddsDisplay*/}
          {/*    current={bet.odds}*/}
          {/*    previous={bet.previouseOdds}*/}
          {/*    flash={flash}*/}
          {/*    showArrow={showArrow}*/}
          {/*    acceptOddsChange={config.acceptOddsChange || false}*/}
          {/*  />*/}
          {/*)}*/}
          {!config.calculationResultBottom && displayRemoveIcon && (
            <BetRemoveButton onRemove={() => removeBets([bet])} label={bet.selectionName} />
          )}
        </div>

        <div className="bet-line text-xs text-muted mt-1"><span>{bet.selectionName}</span> <span>{bet.line}</span></div>

      </div>
    </div>
  );
};

export default BetLine;
